package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class SendSupportMessageRequest(
    val email: String,
    val message: String,
)

@Serializable
data class SupportMessageDto(
    val id: String,
    val email: String,
    val message: String,
    val createdAt: String,
)
